// extracted by mini-css-extract-plugin
module.exports = {"similar":"styles_similar___AR5D","logo":"styles_logo__DYXcW","pulse":"styles_pulse__sjT_i","jump":"styles_jump__ltaGl"};